module.exports = __webpack_public_path__ + "img/card-dress-change.22b6560f.png";